module.exports = __webpack_public_path__ + "static/hand-492x328-1ce3287794e0bcfe03ba240d3198bc4f.jpg";